import HolidayList from "../../../treegrid/holiday-list"
import HolidayCards from "../../../holidays/components/HolidayCards"
import * as holidayApi from "../../../holidays/api"
import { CircularProgress, makeStyles, Theme } from "@material-ui/core"
import { useGetUserInfoQuery } from "../../../users/api"
import { useDateFormat } from "../../../users/hooks/use-date-format"
import { useUserTimeZone } from "../../../hooks/use-user-time-zone"
import { useHolidayMutations } from "../../../holidays/hooks/use-holiday-mutations"
import { useGetHolidaysQuery } from "../../../holidays/api"
import { useFirstDayOfWeek } from "../../../hooks/use-first-day-of-week"
import { useIsSmallScreen } from "../../../hooks/use-is-small-screen"

const UserHolidays = () => {
  const classes = useStyles()
  const { data: user, isLoading: userIsLoading } = useGetUserInfoQuery()
  const { data: holidays = [], isLoading: holidaysAreLoading } = useGetHolidaysQuery(
    { userId: user?.id as string },
    { skip: !user, refetchOnMountOrArgChange: true }
  )
  const { dateFormat, dateSeparator } = useDateFormat()
  const userTimeZone = useUserTimeZone()
  const firstDayOfWeek = useFirstDayOfWeek()
  const { createHoliday } = useHolidayMutations()
  const isSmallScreen = useIsSmallScreen()

  const isLoading = userIsLoading || holidaysAreLoading
  if (isLoading) return <CircularProgress />

  function addHoliday(newHoliday: holidayApi.BaseNewHolidayData) {
    return createHoliday({ ...newHoliday, userId: user?.id as string })
  }

  if (isSmallScreen) {
    return <HolidayCards holidays={holidays} onAddHoliday={addHoliday} canManageHolidays />
  }

  return (
    <div className={classes.viewContainer}>
      <HolidayList
        holidays={holidays}
        dateFormat={dateFormat}
        dateSeparator={dateSeparator}
        timeZone={userTimeZone}
        firstDayOfWeek={firstDayOfWeek}
        onAddHoliday={addHoliday}
        canCreateHoliday={true}
      />
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  viewContainer: {
    marginTop: theme.spacing(1),
    "& > :first-child": {
      marginBottom: theme.spacing(1.125),
    },
  },
}))

export default UserHolidays
